import { Loading, useTranslation } from "@opendash/core";
import { Image, Space } from "antd";
import React, { useEffect, useState } from "react";
import { Schedule_Execution } from "../../../js/parsegenerated";

export function ScheduleImage(props: { schedule: Schedule_Execution }) {
  const t = useTranslation();
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    if (props.schedule) {
      props.schedule
        .relation("media")
        .query()
        .find()
        .then((mediafiles: Parse.Object[]) => {
          const _urls: string[] = mediafiles.map((mediafile) => {
            return mediafile.get("media").url();
          });
          setImageUrls(_urls);
          setLoading(false);
        });
    }
  }, [props.schedule]);

  return (
    <>
      {loading ? (
        <Loading message={t("maintenance:global.loading")} />
      ) : (
        <Image.PreviewGroup>
          <Space>
            {imageUrls.map((image, index) => {
              return <Image width={200} key={index} src={image} />;
            })}
          </Space>
        </Image.PreviewGroup>
      )}
    </>
  );
}
